var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Separator, RightDiv, TextField } from "@atlassiansox/microscopekit";
import { createServiceNotificationMutation, updateServiceNotificationMutation, removeServiceNotificationMutation, CronosExecutionsType } from "../../graphql";
import { LabelWithHelperText } from "../LabelWithHelperText";
import { CheckboxSelect } from "@atlaskit/select";
import { ButtonGroup, LoadingButton } from "@atlaskit/button";
import { useMutationUI } from "../../hooks";
import { isEqual } from "lodash";
var NotificationEditFormComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var serviceId = _a.serviceId, serviceNotification = _a.serviceNotification, setServiceNotification = _a.setServiceNotification;
    var _j = __read(useState(serviceNotification === undefined), 2), isCreateMode = _j[0], setIsCreateMode = _j[1];
    useEffect(function () {
        var _a, _b, _c;
        setIsCreateMode(serviceNotification === undefined ? true : false);
        setSlackChannel((_a = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.channel) !== null && _a !== void 0 ? _a : "");
        setSubscriptions((_b = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.subscriptions) !== null && _b !== void 0 ? _b : []);
        setCronosExecutions((_c = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosExecutions) !== null && _c !== void 0 ? _c : []);
        setCronosReminders(serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosReminders);
    }, [serviceNotification]);
    var _k = __read(useState((_b = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.channel) !== null && _b !== void 0 ? _b : ""), 2), slackChannel = _k[0], setSlackChannel = _k[1];
    var _l = __read(useState((_c = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.subscriptions) !== null && _c !== void 0 ? _c : []), 2), subscriptions = _l[0], setSubscriptions = _l[1];
    var _m = __read(useState((_d = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosExecutions) !== null && _d !== void 0 ? _d : []), 2), cronosExecutions = _m[0], setCronosExecutions = _m[1];
    var _o = __read(useState(serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosReminders), 2), cronosReminders = _o[0], setCronosReminders = _o[1];
    var _p = useMutationUI({
        mutation: createServiceNotificationMutation,
        successMessage: "Notifications enabled successfully",
        options: {
            variables: {
                input: {
                    channel: slackChannel,
                    service: serviceId,
                    subscriptions: subscriptions,
                    cronosExecutions: cronosExecutions,
                    cronosReminders: cronosReminders
                }
            },
            onCompleted: function (_a) {
                var configureNotification = _a.configureNotification;
                setServiceNotification(configureNotification);
                setIsCreateMode(false);
            }
        }
    }), createNotification = _p.mutate, isCreateLoading = _p.isLoading;
    var _q = useMutationUI({
        mutation: updateServiceNotificationMutation,
        successMessage: "Notifications updated successfully",
        options: {
            variables: {
                input: {
                    channel: slackChannel,
                    service: serviceId,
                    subscriptions: subscriptions,
                    cronosExecutions: cronosExecutions,
                    cronosReminders: cronosReminders
                }
            },
            onCompleted: function (_a) {
                var updateServiceNotification = _a.updateServiceNotification;
                setServiceNotification(updateServiceNotification);
                setIsCreateMode(false);
            }
        }
    }), updateNotification = _q.mutate, isUpdateLoading = _q.isLoading;
    var _r = useMutationUI({
        mutation: removeServiceNotificationMutation,
        successMessage: "Notifications disabled successfully",
        options: {
            variables: {
                id: (_e = serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.id) !== null && _e !== void 0 ? _e : ""
            },
            onCompleted: function () {
                setServiceNotification(undefined);
                setIsCreateMode(true);
            }
        }
    }), removeNotification = _r.mutate, isDeleteLoading = _r.isLoading;
    return (React.createElement("div", null,
        React.createElement("br", null),
        React.createElement("label", null, "Slack Channel"),
        React.createElement(TextField, { name: "Slack Channel", value: slackChannel, onChange: function (e) {
                setSlackChannel(e.target.value);
            }, placeholder: "Slack Channel" }),
        React.createElement("h4", null, "On-Demand Wargames"),
        React.createElement(Separator, null),
        React.createElement("br", null),
        React.createElement("label", null, "Subscriptions"),
        React.createElement(CheckboxSelect, { inputId: "subscriptions-select", className: "subscriptions-select", classNamePrefix: "subscriptions-select", options: [
                { label: "wargame", value: "wargame" },
                { label: "schedule", value: "schedule" }
            ], placeholder: "Select Subscriptions", required: true, onChange: function (selectedOptions) {
                setSubscriptions(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) { return option.value; }));
            }, value: (_f = subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.map(function (val) { return ({ label: val, value: val }); })) !== null && _f !== void 0 ? _f : [] }),
        React.createElement("h4", null, "Continuous Chaos"),
        React.createElement(Separator, null),
        React.createElement("br", null),
        React.createElement("label", null, "Subscriptions"),
        React.createElement(CheckboxSelect, { inputId: "executions-select", className: "executions-select", classNamePrefix: "executions-select", options: [
                {
                    label: CronosExecutionsType.terminate_instances,
                    value: CronosExecutionsType.terminate_instances
                },
                {
                    label: CronosExecutionsType.az_failure,
                    value: CronosExecutionsType.az_failure
                }
            ], placeholder: "Select Subscriptions", required: true, onChange: function (selectedOptions) {
                setCronosExecutions(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) { return option.value; }));
            }, value: (_g = cronosExecutions === null || cronosExecutions === void 0 ? void 0 : cronosExecutions.map(function (val) { return ({ label: val, value: val }); })) !== null && _g !== void 0 ? _g : [] }),
        React.createElement(Separator, null),
        React.createElement("br", null),
        React.createElement(LabelWithHelperText, { label: "Reminders", helperText: "A reminder will be dispatched both one day and seven days prior to the scheduled continuous chaos execution." }),
        React.createElement(CheckboxSelect, { inputId: "reminders-select", className: "reminders-select", classNamePrefix: "reminders-select", options: [{ label: "az_failure", value: "az_failure" }], placeholder: "Select Reminders", required: true, onChange: function (selectedOptions) {
                setCronosReminders(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.reduce(function (acc, option) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[option.value] = 7, _a)));
                }, {}));
            }, value: (_h = Object.keys(cronosReminders || {}).map(function (key) { return ({
                label: key,
                value: key
            }); })) !== null && _h !== void 0 ? _h : [] }),
        React.createElement("br", null),
        React.createElement(RightDiv, null,
            React.createElement(ButtonGroup, null,
                React.createElement(LoadingButton, { onClick: function () { return removeNotification(); }, appearance: "danger", isLoading: isDeleteLoading, isDisabled: isCreateMode }, "Disable"),
                React.createElement(LoadingButton, { onClick: function () {
                        return isCreateMode ? createNotification() : updateNotification();
                    }, appearance: "primary", isLoading: isCreateMode ? isCreateLoading : isUpdateLoading, isDisabled: slackChannel.length === 0 ||
                        (slackChannel === (serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.channel) &&
                            isEqual(subscriptions, serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.subscriptions) &&
                            isEqual(cronosExecutions, serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosExecutions) &&
                            isEqual(cronosReminders, serviceNotification === null || serviceNotification === void 0 ? void 0 : serviceNotification.cronosReminders)) }, "Save")))));
};
export var NotificationEditForm = NotificationEditFormComponent;
